export { default as Img200 } from './processed/200/Ancient-Assassins-2.jpg';
export { default as Img400 } from './processed/400/Ancient-Assassins-2.jpg';
export { default as Imgthumb } from './processed/thumb/Ancient-Assassins-2.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Ancient-Assassins-2.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Ancient-Assassins-2.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Muted": {
    "_rgb": [
      117,
      118,
      135
    ],
    "_population": 1337,
    "_hsl": [
      0.6574074074074073,
      0.07142857142857145,
      0.49411764705882355
    ]
  },
  "LightMuted": {
    "_rgb": [
      194,
      188,
      193
    ],
    "_population": 1779,
    "_hsl": [
      0.8611111111111112,
      0.04687499999999983,
      0.7490196078431373
    ]
  },
  "DarkMuted": {
    "_rgb": [
      65,
      69,
      74
    ],
    "_population": 2007,
    "_hsl": [
      0.5925925925925927,
      0.06474820143884899,
      0.27254901960784317
    ]
  },
  "Vibrant": {
    "_rgb": [
      0,
      0,
      0
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Ancient-Assassins-2.js